import type { RydeUiUnit } from "@ryde/shared";

export const PERCENTAGE_MULTIPLIER = 100;
export const MIN_PROGRESS_VALUE = 0;
export const PROCESS_CHUNK_COUNT = 5;

export const GENERIC_UPLOAD_PASSENGER_ENTITY: RydeUiUnit = "passenger";
export const GENERIC_UPLOAD_PHONE_FIELD = "phoneMobile";
/** Backend cap on one phones-in-use request. */
export const PHONES_IN_USE_REQUEST_CHUNK_SIZE = 2000;
export const UPLOAD_PHONE_ISRAEL_COUNTRY_CODE = "972";
/** Trunk prefix of an Israeli number as a sheet types it ("052-380 9898"). */
export const UPLOAD_PHONE_NATIONAL_TRUNK_PREFIX = "0";
/** Digits of an Israeli national number without its trunk prefix ("523809898"). */
export const UPLOAD_PHONE_NATIONAL_LENGTH_WITHOUT_TRUNK = 9;
